var app = angular.module('leonardo');

var TemplateService = function(BaseRestService, $q, RestangularProvider) {
  var service = new BaseRestService('templates', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('templates', false, function(template) {
      template.addRestangularMethod('changeStatus', 'post', 'change-status');
      template.addRestangularMethod('setRecurrence', 'post', 'recurrence');
      template.addRestangularMethod('setPriority', 'post', 'priority');
      template.addRestangularMethod('assignUsers', 'post', 'assign-users');
      template.addRestangularMethod('assignVendors', 'post', 'assign-vendors');
      template.addRestangularMethod('deactivate', 'post', 'deactivate');
      template.addRestangularMethod('cloneToWhiteLabel', 'post', 'clone-to-whitelabel');
      return template;
    });
  });

  service.acceptAudit = function(id) {
    return RestangularProvider.one('templates', id).customPOST({}, 'audit/accept');
  };

  service.rejectAudit = function(id) {
    return RestangularProvider.one('templates', id).customPOST({}, 'audit/reject');
  };

  service.disableAll = function(params) {
    return RestangularProvider.all('templates').customPOST(params, 'disable-all');
  };

  service.changeStatusAll = function(params) {
    return RestangularProvider.all('templates').customPOST(params, 'change-status-all');
  };

  service.getReports = function(params) {
    return RestangularProvider.all('templates').customGET('report', params);
  };

  service.getCalendar = function(params) {
    return RestangularProvider.all('templates').customGET('calendar', params);
  };

  service.bulkExport = function(params, headers) {
    return RestangularProvider.all('templates').customGET('export-excel', params, headers);
  };

  service.bulkImport = function(params, headers) {
    return RestangularProvider.all('templates').customGET('bulk-import-excel', params, headers);
  };

  // Constants
  service.STATUS_PUBLISHED = '0';
  service.STATUS_UNPUBLISHED = '1';
  service.STATUS_DEACTIVATED = '2';

  service.TYPE_SYSTEM = '0';
  service.TYPE_ACCOUNT = '1';
  service.TYPE_PORTFOLIO = '2';
  service.TYPE_PROPERTY = '3';
  service.TYPE_ACCOUNT_USER = '4';
  service.TYPE_SYSTEM_WORKFLOW = '5';
  service.TYPE_ACCOUNT_WORKFLOW = '6';
  service.TYPE_TRIGGER= '7';

  service.CATEGORY_CODE = '17';

  service.TYPE_OPTIONS = [
    {
      id: service.TYPE_SYSTEM,
      name: 'System'
    },
    {
      id: service.TYPE_ACCOUNT,
      name: 'Account'
    },
    {
      id: service.TYPE_PORTFOLIO,
      name: 'Portfolio'
    },
    {
      id: service.TYPE_PROPERTY,
      name: 'Property'
    },
    {
      id: service.TYPE_ACCOUNT_USER,
      name: 'Account User'
    },
    {
      id: service.TYPE_SYSTEM_WORKFLOW,
      name: 'System Workflow'
    },
    {
      id: service.TYPE_ACCOUNT_WORKFLOW,
      name: 'Account Workflow'
    },
    {
      id: service.TYPE_TRIGGER,
      name: 'Trigger'
    }
  ];

  service.NOT_APPLICABLE = '0';
  service.APPLICABLE = '1';

  service.APPLICABLE_OPTIONS = [
    {
      id: service.APPLICABLE,
      name: 'Applicable'
    },
    {
      id: service.NOT_APPLICABLE,
      name: 'Not Applicable'
    }
  ];

  service.PRIORITY_MINOR = '0';
  service.PRIORITY_NORMAL = '1';
  service.PRIORITY_CRITICAL = '2';

  service.TYPE_LAG_SS = '0';
  service.TYPE_LAG_FS = '1';

  service.LAG_TYPES = [
    {
      id: service.TYPE_LAG_FS,
      name: 'FS',
      help: 'Select Finish-to-Start (FS) if this task should only start after the predecessor task has finished.'
    },
    {
      id: service.TYPE_LAG_SS,
      name: 'SS',
      help: 'Select Start-to-Start (SS) if this task can start anytime after the predecessor task has started. Lag will determine how many days after the finish or start date the task will appear. Leave lag at 0 if the child task begins immediately upon the finish or start of the predecessor task.'
    }
  ];

  service.PRIORITY_OPTIONS = [
    {
      id: service.PRIORITY_CRITICAL,
      name: 'Critical'
    },
    {
      id: service.PRIORITY_NORMAL,
      name: 'Normal'
    },
    {
      id: service.PRIORITY_MINOR,
      name: 'Minor'
    }
  ];

  service.RECURRENCE_DAILY = '0';
  service.RECURRENCE_MONTHLY = '1';
  service.RECURRENCE_YEARLY = '2';
  service.RECURRENCE_FIXED_DATE = '3';
  service.RECURRENCE_WEEKLY = '4';

  service.RECURRENCE_OPTIONS = [
    {
      id: service.RECURRENCE_DAILY,
      name: 'Daily'
    },
    {
      id: service.RECURRENCE_FIXED_DATE,
      name: 'Fixed date'
    },
    {
      id: service.RECURRENCE_WEEKLY,
      name: 'Weekly'
    },
    {
      id: service.RECURRENCE_MONTHLY,
      name: 'Monthly'
    },
    {
      id: service.RECURRENCE_YEARLY,
      name: 'Yearly'
    }
  ];

  service.RECURRENCE_WEEKLY_OPTIONS = [
    {
      id: 6,
      name: 'sunday'
    },
    {
      id: 0,
      name: 'monday'
    },
    {
      id: 1,
      name: 'tuesday'
    },
    {
      id: 2,
      name: 'wednesday'
    },
    {
      id: 3,
      name: 'thursday'
    },
    {
      id: 4,
      name: 'friday'
    },
    {
      id: 5,
      name: 'saturday'
    }
  ];

  service.RECURRENCE_MONTHLY_OPTIONS = ['week1', 'week2', 'week3', 'last_week'];

  service.RECURRENCE_POSITION_IN_MONTH = [
        {id:0, name: 'First'},
        {id:1, name: 'Second'},
        {id:2, name: 'Third'},
        {id:3, name: 'Fourth'}
      ];

  service.RECURRENCE_YEARLY_OPTIONS = [
    'january', 'february', 'march', 'april', 'may', 'june',
    'july', 'august', 'september', 'october', 'november', 'december'
  ];

  service.RECURRENCE_INTERVAL_OPTIONS = ['years', 'months', 'weeks'];

  service.bulkObject = function(account) {
    return {
      account: account,
      recurrence: {},
      attachments: [],
      fields: {}
    };
  };

  return service;
};

app.factory('TemplateService', ['BaseRestService', '$q', 'Restangular', TemplateService]);
